import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { CartContext } from "../../../../../../contexts/cartContext";
import api from "../../../../../../../utils/apiUsers";
// import renderData from "../../../../../../../utils/renderData";
// import MyIcons from "../../../../../../golbal/icons/myIcons";
import tools from "../../../../../../../utils/tools";
import ColoredSpinner from "../../../../../../alret/spiners/coloredSpiner/coloredSpinner";
import MetaDecorator from "../../../../../../../utils/metaDecorator";

export default function WalletDetails() {
  const { user } = useContext(CartContext);
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  console.log(data);
  const { lang, state:{state,stateShort,lat,lng}, country, countryShort } =
  tools.getItemFromLocalStorage("initSetup", {});
  const countryDetails =
    JSON.parse(localStorage?.getItem("countryDetails")) ?? {};

    const trans = {
      total:{en:'Total',fa:"جمع کل"},
      group:{en:'Group',fa:"گروه"},
      desc:{en:'Descriptions',fa:"توضیحات"},
      amount:{en:'Amount',fa:"مبلغ"},
      date:{en:'Date',fa:"تاریخ"},
      walDetails:{en:'Points Details',fa:"جزئیات کیف پول"},
      HeadDesc:{en:'View wallet transactions History',fa:"مشاهده تراکنش های کیف پول"},
     
    }
  
  
    useEffect(() => {
    (async () => {
      setLoading(true);
      const response = await api.getWalletDetails({
        token: user.token,
        id: user._id,
      });
      setLoading(false);
      if (response.error) return alert(response.error);
      const subtotal = response.data.reduce((a, c) => a + Number(c.amount), 0);
      const newData = [
        ...response.data,
        {
          _id: "subtotal",
          type: "subtotal",
          amount: subtotal,
          createdAt: "",
          targetIdentifier: { description: trans.total[window.lang] },
        },
      ];

      setData(newData);
    })();
  }, []);


  const subtotal = data.reduce((a, c) => a + Number(c.amount), 0);
  const columns = [
    {
      field: "type",
      headerName:  trans.group[window.lang],
      width: 150,
      renderCell: (params) => {
        const trans = tools.renderTrans({
          section: "walletDesc",
          key: params.row?.type,
        });
        // const group = pointsGroups.find(group => group.name === params.row?.type)
        return <div title={trans}> {trans}</div>;
      },
    },
    {
      field: "targetIdentifier.description",
      headerName: trans.desc[window.lang],
      width: 280,
      renderCell: (params) => {
        return (
          <strong title={params.row?.targetIdentifier?.description}>
            {" "}
            {params.row?.targetIdentifier?.description}
          </strong>
        );
      },
    },
    {
      field: "amount",
      headerName:  trans.amount[window.lang],
      width: 120,
      renderCell: (params) => {
        return (
          <strong>
            {tools.showPrice(
              params.row?.amount * countryDetails.exRate,
              countryDetails.currency
            )}
          </strong>
        );
      },
    },
    {
      field: "createdAt",
      headerName: trans.date[window.lang],
      width: 160,
      renderCell: (params) => (
        <div>
          {tools.dynamicDate({
            date: params.row?.createdAt,
            lang: window.lang,
            countryShort,
            showYear: true,
          })}
        </div>
      ),
    },
  ];
  const metaTagsData = {
    title: trans.walDetails[window.lang],
    description:trans.HeadDesc[window.lang],
    section: "Wallet list",
    url: `${window.location.origin}/${window.lang}/dashboard/user/trans/points`,
    img: "https://www.metamarce.com/img/illustration/buy-photography-gear-online.svg",
    type: "webpage",
    index: false,
  };

  return (
    <div className="userList" style={{ height: "100vh", width: "100%" }}>
      <MetaDecorator data={{ ...metaTagsData }} />

      {loading && <ColoredSpinner />}
      <DataGrid
        getRowId={(row) => row._id}
        rows={data}
        components={{
          Toolbar: GridToolbar,
        }}
        disableSelectionOnClick
        columns={columns}
        pageSize={[12]}
        rowsPerPageOptions={[1]}
        checkboxSelection
      />
    </div>
  );

  function CustomFooter({ totalRowCount, subtotal }) {
    return (
      <div style={{ padding: "10px", borderTop: "1px solid #ccc" }}>
        <div>Total rows: {totalRowCount}</div>
        <div>Subtotal: {subtotal}</div>
      </div>
    );
  }
}
